module.exports = __webpack_public_path__ + "src/assets/img/indicator.734ab12a.jpg";